module.exports = __webpack_public_path__ + "static/img/ryj@2x.5aa35ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ryj@2x.png
// module id = kQXK
// module chunks = 2